import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

/**
 * Select en el que se escribe para filtrar las opciones, para listas largas
 * como bloques y salones. Las opciones ya estan cargadas: el filtro es local
 * y no distingue mayusculas ni tildes ("areas" encuentra "ÁREAS LIBRES").
 *
 * Trabaja con el id, igual que un select: recibe el id elegido y entrega el
 * nuevo id, o "" si se borra.
 */
const SelectorBuscable = ({
  etiqueta,
  valor,
  opciones,
  onChange,
  error,
  ayuda,
  deshabilitado,
  cargando,
  margin,
}) => {
  const elegida = opciones.find(({ id }) => `${id}` === `${valor}`) ?? null;

  return (
    <Autocomplete
      value={elegida}
      options={opciones}
      disabled={deshabilitado}
      loading={cargando}
      getOptionLabel={({ nombre }) => nombre}
      getOptionSelected={(una, otra) => una.id === otra.id}
      onChange={(_evento, opcion) => onChange(opcion ? opcion.id : "")}
      noOptionsText="Sin coincidencias"
      loadingText="Cargando..."
      renderInput={(parametros) => (
        <TextField
          {...parametros}
          label={etiqueta}
          placeholder="Escribe para buscar"
          fullWidth
          margin={margin}
          error={Boolean(error)}
          helperText={error || ayuda}
        />
      )}
    />
  );
};

SelectorBuscable.propTypes = {
  etiqueta: PropTypes.string.isRequired,
  valor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  opciones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      nombre: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  ayuda: PropTypes.string,
  deshabilitado: PropTypes.bool,
  cargando: PropTypes.bool,
  margin: PropTypes.oneOf(["none", "dense", "normal"]),
};

SelectorBuscable.defaultProps = {
  error: "",
  ayuda: "",
  deshabilitado: false,
  cargando: false,
  margin: "none",
};

export default SelectorBuscable;
